import { render, staticRenderFns } from "./BodyAnatomy.vue?vue&type=template&id=46564700&"
import script from "./BodyAnatomy.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports